import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { BILLING_MPA_URL } from "@/store/entitlementsStore";
import { AuthLayout } from "@/features/auth/components/AuthLayout";

/**
 * Self-serve signup lives on the billing MPA.
 * This SPA page only explains where to subscribe.
 */
export default function RegisterPage() {
  const billingUrl = BILLING_MPA_URL;

  return (
    <AuthLayout
      title="Create your account"
      description="Subscriptions and company signup are handled on our billing site. After you subscribe, return here to sign in."
    >
      <div className="flex flex-col gap-5">
        {billingUrl ? (
          <Button
            asChild
            className="w-full motion-safe:transition-transform motion-safe:duration-200 motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-panel"
          >
            <a href={billingUrl} rel="noopener noreferrer">
              Continue to billing
              <ExternalLink className="h-4 w-4" />
            </a>
          </Button>
        ) : (
          <p className="rounded-sm border border-tide bg-foam px-3 py-2.5 font-mono text-meta leading-relaxed text-slate-current">
            Billing site URL is not configured (
            <code className="text-financial-ink">VITE_BILLING_MPA_URL</code>).
            Use the local harness at{" "}
            <code className="text-financial-ink">tools/billing-harness</code>{" "}
            during development.
          </p>
        )}
        <p className="text-center text-sm text-slate-current">
          Already have an account?{" "}
          <Link
            to="/login"
            className="font-medium text-exec underline-offset-4 hover:underline"
          >
            Sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
